import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CIcon from '@coreui/icons-react'
import { cilSend, cilPlus, cilMinus, cilStar } from '@coreui/icons'
import { CButton, CCardText, CCol, CRow, CCard, CCardBody, CImage, CCardTitle } from '@coreui/react'
import apiClient from '../../services/apiClient'
import { buildApiUrl } from '../../utils/getConfiguration'

const WidgetFinanceProvider = (props) => {
  const [moneyrequests, setMoneyrequests] = useState([])

  const fetchMoneyrequestsData = async () => {
    try {
      // Example: buildApiUrl('accountFinances', {
      //   account_ID: localStorage.getItem('account_ID'),
      //   grp_ID: localStorage.getItem('grp_ID'),
      // })
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(
        buildApiUrl('accountFinances', {
          account_ID,
          grp_ID,
        }),
      )
      //window.location.reload()
      setMoneyrequests(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchMoneyrequestsData()
  }, [])

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CCol>
          <div className="small text-medium-emphasis">
            {moneyrequests.length > 0 ? (
              <div>
                <h4 id="traffic" className="card-title mb-0">
                  <p id="caption 2">Select your provider for: CZECHIA</p>
                </h4>
                {moneyrequests.map((moneyrequest) => (
                  <div key={moneyrequest.finance_id}>
                    {/*{recommendation.reminder_ID === localStorage.getItem('taskid') && (*/}
                    <div key={moneyrequest.finance_id}>
                      <div>
                        <CCard key={1} sm={2} className="mb-4">
                          <CCardBody>
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                              <CCol>
                                {/*<CCardImage orientation="top" src={avatar2} />*/}
                                <CImage
                                  rounded
                                  orientation="top"
                                  src={moneyrequest.financePic}
                                  height={50}
                                />
                                <CCardTitle>{moneyrequest.financeName}</CCardTitle>
                                <CCardText className="p-1">
                                  Contact: {moneyrequest.financeContactName}
                                </CCardText>
                              </CCol>
                              <CCol>
                                {/*
                                <WidgetFinance parameter={moneyrequest.finance_id} />
                                */}
                                <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                                  <div className="p-1">Select:</div>
                                  <CButton
                                    color="success"
                                    onClick={() => {
                                      console.log('Select provider')
                                      //localStorage.setItem('taskid', recommendation.reminder_ID)
                                      //handleClickDone()
                                    }}
                                  >
                                    <CIcon icon={cilStar} size="xxl" />
                                  </CButton>
                                </div>
                              </CCol>
                            </div>
                          </CCardBody>
                        </CCard>
                        {/*<CRow>
                          <WidgetsDropdown />
                        </CRow>*/}
                      </div>
                    </div>
                    {/*)}*/}
                  </div>
                ))}
              </div>
            ) : (
              <CCol>
                <CCardText className="alert alert-danger">
                  Service not available in your country...
                  {/*{localStorage.getItem('taskid')}*/}
                </CCardText>
              </CCol>
            )}
          </div>
        </CCol>
      </CCardBody>
    </CCard>
  )
}

WidgetFinanceProvider.propTypes = {
  parameter: PropTypes.string.isRequired,
}
export default WidgetFinanceProvider
